<template>
	<div class="action-button-wrapper">
      <b-button size="sm" variant="link" @click="emitAction('edit')" class="site-action-btn">
          <span class="icon-cont">
              <write-icon class="icon-default write-icon"></write-icon>
          </span>
          <span>Edit site details</span>
      </b-button>
  </div>
</template>

<script>
import WriteIcon from '../../assets/write.svg';
export default {
  name: "viewsite",
  props: ["site"],
  components:{
  	WriteIcon
  },
  data() {
    return {
      serverURL: window.serverURL,
    };
  },
  methods:{
    emitAction(action) {
      this.$emit('action', { action: action, site: this.site });
    },
  }
};
</script>